import { render, staticRenderFns } from "./CodeRadioGroup.vue?vue&type=template&id=209b89bc"
import script from "./CodeRadioGroup.vue?vue&type=script&lang=js"
export * from "./CodeRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports